export default "__VITE_ASSET__DWmxugKR__"